import { Row, Col } from "react-bootstrap";
import Timelineitem from "./Timelineitem";

const TimnelineTab = ({
  posts,
  editAction,
  deleteAction,
  setDraft,
  setEditPost,
  setShowVariants,
  publish,
  setPosts,
  useSchedule = false,
  markInProgress,
  setActiveKey,
  telepromterAction,
  shareAction
}) => {
  return (
    <Row>
      <Col md={12}>
        {posts.map((item, index) => {
          let post = item;
          let schedule;
          if (useSchedule) {
            post = item.post;
            schedule = item;
          }
          return (
            <Timelineitem
              schedule={useSchedule ? schedule : null}
              key={useSchedule ? item.id : post.id}
              post={post}
              publish={publish}
              editAction={() => {
                editAction(post);
              }}
              deleteAction={() => {
                deleteAction(setPosts, posts, index, post.id);
              }}
              setDraftAction={() => {
                setDraft(post, posts);
              }}
              markInProgress={() => {
                markInProgress(post, posts);
              }}
              creatVariantsAction={() => {
                setEditPost(post);
                setShowVariants(true);
                setActiveKey('content');
              }}
              createIdeasAction={() => {
                setEditPost(post);
                setShowVariants(true);
                setActiveKey('ideas');
              }}
              telepromterAction={() => {
                telepromterAction(post)
              }}
              shareAction={shareAction}
            />
          );
        })}
      </Col>
    </Row>
  );
};

export default TimnelineTab;
